module.exports = __webpack_public_path__ + "img/nodata2.a4611c12.svg";